import { createI18n } from "vue-i18n"
import messages from "@intlify/unplugin-vue-i18n/messages"

const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  globalInjection: true,
  allowHTMLMessage: true,
  warnHtmlInMessage: false,
  messages
})

export default i18n
